'use client'

import { Button, useDevice } from '@lune-fe/lune-ui-lib'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import BlogCardOld from '@/components/BlogCardOld'

const posts = [
    {
        imageSrc:
            'https://images.prismic.io/luneco/aZQ1aFWLo0XkEkhB_mergerheader-2-.png?auto=compress,format',
        href: '/blog/lune-and-gryn-merge-to-create-the-leading-supply-chain-co2-intelligence-platform',
        title: 'Lune and gryn merge to create the leading supply chain CO₂ intelligence platform',
        formattedDate: 'January 20, 2026',
    },
    {
        imageSrc:
            'https://images.prismic.io/luneco/abvXK7bci2UF6RHO_shippers-spreadsheets.png?auto=compress,format',
        href: '/blog/why-enterprise-shippers-are-still-getting-freight-emissions-wrong-and-how-to-fix-it',
        title: 'Why enterprise shippers are still getting freight emissions wrong (and how to fix it)',
        formattedDate: 'March 19, 2026',
    },
    {
        imageSrc:
            'https://images.prismic.io/luneco/aLcWNGGNHVfTOh9l_tenderblog.png?auto=compress,format',
        href: '/blog/the-rise-of-emission-requests-in-shipping-tenders',
        title: 'The rise of emission requests in shipping tenders',
        formattedDate: 'September 30, 2025',
    },
]

const HomePageBlogPosts: FC = () => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: smScreen ? 7 : 9,
                flexDirection: 'column',
            }}
        >
            <Text variant={smScreen ? 'h5' : 'h4'}>Emissions intelligence insights</Text>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: smScreen ? 5 : 2,
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                }}
            >
                {posts.map((post) => (
                    <BlogCardOld
                        key={post.href}
                        sx={{ flex: smScreen ? '0 0 100%' : '0 0 calc(33.33% - 16px)' }}
                        imageSrc={post.imageSrc}
                        href={post.href}
                        title={post.title}
                        formattedDate={post.formattedDate}
                        imageFill
                    />
                ))}
            </Box>
            <Button
                variant={'outlined'}
                href={'/blog'}
                sx={{ width: smScreen ? '100%' : 'auto' }}
                leftIcon={<ArrowForwardOutlinedIcon />}
            >
                Explore our blog
            </Button>
        </Box>
    )
}

export default HomePageBlogPosts
